module.exports = "../fonts/slick.woff";


//////////////////
// WEBPACK FOOTER
// ./@fonts/slick.woff
// module id = 517
// module chunks = 7